import { render } from "./EditTestimonialDialog.vue?vue&type=template&id=5e0fb7ba&scoped=true"
import script from "./EditTestimonialDialog.vue?vue&type=script&lang=js"
export * from "./EditTestimonialDialog.vue?vue&type=script&lang=js"

import "./EditTestimonialDialog.vue?vue&type=style&index=0&id=5e0fb7ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0fb7ba"]])

export default __exports__